import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { formatTime } from "../../lib/format";

const time = (iso) => formatTime(iso);

export const ReportTable = ({ rows }) => {
  const { t } = useTranslation();
  const cols = ["reports.employee", "check.branch", "reports.date", "reports.checkIn", "reports.checkOut", "check.late", "check.worked", "check.overtime"];

  return (
    <NeuCard className="overflow-x-auto p-4" data-testid="report-table">
      {rows.length === 0 ? (
        <p className="p-6 text-center text-sm text-muted-foreground">{t("reports.empty")}</p>
      ) : (
        <table className="w-full min-w-[760px] text-start text-sm">
          <thead>
            <tr className="border-b border-border/60">
              {cols.map((c) => (
                <th key={c} className="px-3 py-3 text-start text-[11px] tracking-normal text-muted-foreground">
                  {t(c)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`report-row-${r.id}`} className="border-b border-border/30">
                <td className="px-3 py-3 font-semibold">{r.employee_name}</td>
                <td className="px-3 py-3 text-muted-foreground">{r.branch_name}</td>
                <td className="px-3 py-3 font-mono">{r.date}</td>
                <td className="px-3 py-3 font-mono">{time(r.check_in_at)}</td>
                <td className="px-3 py-3 font-mono">{time(r.check_out_at)}</td>
                <td className={`px-3 py-3 font-mono ${r.late_minutes ? "text-destructive" : ""}`}>{r.late_minutes}</td>
                <td className="px-3 py-3 font-mono">{(r.worked_minutes / 60).toFixed(1)}</td>
                <td className="px-3 py-3 font-mono text-primary">{r.overtime_minutes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </NeuCard>
  );
};
